<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <h1 class="title-default">Automações de ordem de serviço</h1>
    <p class="welcome-message">
      <button mat-icon-button routerLink="/configuracoes/servicos" matTooltip="Voltar">
        <mat-icon>arrow_back</mat-icon>
      </button>
      Escolha as automações que você quer ativar. Em seguida, defina o momento em que cada ação deve
      acontecer.
    </p>
    <button mat-button type="button" (click)="alternarComoFunciona()">
      <mat-icon class="material-symbols-outlined">help</mat-icon>
      {{ mostrarComoFunciona ? 'Ocultar ajuda' : 'Como funciona' }}
    </button>

    @if (mostrarComoFunciona) {
      <div class="como-funciona">
        <img src="assets/images/empty-list.png" alt="" class="como-funciona-mascote" />
        <div class="como-funciona-copy">
          <strong>Como funciona</strong>
          <p>
            Três passos para automatizar as etapas que hoje você faz manualmente. Cada automação age só no momento
            que você definir, e você pode desativar ou trocar o gatilho depois.
          </p>
          <ol>
            <li>Ligue as automações que deseja usar.</li>
            <li>Escolha quando cada ação acontece.</li>
            <li>Salve e o sistema passa a executar essas etapas para você.</li>
          </ol>
        </div>
      </div>
    }

    @if (isLoading) {
      <app-loading-box height="78" marginTop="24"></app-loading-box>
      <app-loading-box height="58" marginTop="24"></app-loading-box>
      <app-loading-box height="24" width="240" marginTop="56"></app-loading-box>
      <app-loading-box height="16" width="380" marginTop="8"></app-loading-box>
      <div class="automation-list mt-4">
        @for (item of linhas; track item.gatilhoCtrl) {
          <div class="automation-row">
            <app-loading-box class="skeleton-identity" height="104"></app-loading-box>
            <span class="connector"></span>
            <app-loading-box class="skeleton-config" height="104"></app-loading-box>
          </div>
        }
        <div class="automation-row">
          <app-loading-box class="skeleton-identity" height="180"></app-loading-box>
          <span class="connector"></span>
          <app-loading-box class="skeleton-config" height="180"></app-loading-box>
        </div>
      </div>
    } @else {
      <app-alert-card class="mt-4" type="warning" title="Lembre-se de salvar suas automações">
        Nada passa a valer no sistema antes de você salvar.
      </app-alert-card>
      <app-alert-card type="info">
        Ativar ou desativar uma automação não afeta ordens já processadas — vale apenas para as próximas. Ao
        mover um card para um status com automação, o sistema pede confirmação antes de executar.
      </app-alert-card>

      <section class="section-container" [formGroup]="model">
        <div class="section-title section-title-actions">
          <div class="d-flex align-items-center gap-2">
            <mat-icon class="material-symbols-outlined">bolt</mat-icon>
            <span>Ordem de serviço</span>
          </div>
          <span class="status-badge badge-cinza ms-auto">{{ contadorAtivas }}</span>
        </div>
        <p class="section-sub-title">Notas fiscais, financeiro, movimentação e reserva de estoque.</p>

        <div class="automation-list">
          @for (linha of linhas; track linha.gatilhoCtrl) {
            <div class="automation-row">
              <div class="identity-card">
                <span class="identity-icon">
                  <mat-icon class="material-symbols-outlined">{{ linha.icone }}</mat-icon>
                </span>
                <div class="identity-copy">
                  <strong>{{ linha.nome }}</strong>
                  <p>{{ linha.descricao }}</p>
                  @if (isOrfao(linha)) {
                    <app-alert-card class="mt-3" type="warning">
                      A etapa escolhida como gatilho não existe mais ou deixou de ser válida. Escolha outra.
                    </app-alert-card>
                  } @else if (isPendente(linha)) {
                    <app-alert-card class="mt-3" [type]="tentouSalvar ? 'warning' : 'info'">
                      Escolha o gatilho para manter esta automação ativa.
                    </app-alert-card>
                  }
                  <p class="info-hint">
                    <mat-icon class="material-symbols-outlined">lock</mat-icon>
                    {{ linha.nota }}
                  </p>
                </div>
              </div>
              <span class="connector"></span>
              <div class="config-card" [class.config-card--invalid]="tentouSalvar && isPendente(linha)">
                <div class="inline-control">
                  <span>Quando</span>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                    <mat-label>Selecione o gatilho</mat-label>
                    <mat-select [formControlName]="linha.gatilhoCtrl" [compareWith]="compararGatilhos">
                      @for (opcao of linha.opcoes; track opcao.idOpcao + '-' + opcao.idEtapaKanban) {
                        <mat-option [value]="{ idOpcao: opcao.idOpcao, idEtapaKanban: opcao.idEtapaKanban }">
                          {{ opcao.rotulo }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <span class="divider"></span>
                <mat-slide-toggle
                  class="app-toggle-compact"
                  color="primary"
                  [formControlName]="linha.ativoCtrl"
                  [matTooltip]="isAtiva(linha) ? 'Desativar automação' : 'Ativar automação'">
                </mat-slide-toggle>
              </div>
            </div>
          }

          <div class="automation-row">
            <div class="identity-card">
              <span class="identity-icon">
                <mat-icon class="material-symbols-outlined">timer_off</mat-icon>
              </span>
              <div class="identity-copy">
                <strong class="me-2">Liberar reserva ao expirar a ordem de serviço</strong>
                <span class="status-badge badge-azul">Tempo decorrido</span>
                <p>
                  Quando a validade do orçamento da ordem vence, a reserva de estoque é liberada ou os
                  responsáveis são avisados.
                </p>
                @if (isLiberacaoPendente) {
                  <app-alert-card class="mt-3" [type]="tentouSalvar ? 'warning' : 'info'">
                    {{ textoPendenciaLiberacao }}
                  </app-alert-card>
                }
              </div>
            </div>
            <span class="connector"></span>
            <div
              class="config-card config-card--stacked"
              [class.config-card--invalid]="tentouSalvar && isLiberacaoPendente">
              <div class="stacked-header">
                <div class="inline-control">
                  <span>Contar de</span>
                  <div class="ref-box">Data de emissão do orçamento da ordem de serviço</div>
                </div>
                <mat-slide-toggle
                  class="app-toggle-compact"
                  color="primary"
                  formControlName="isAtivoLiberacaoReserva"
                  [matTooltip]="isLiberacaoAtiva ? 'Desativar automação' : 'Ativar automação'">
                </mat-slide-toggle>
              </div>
              <span class="divider"></span>
              <div class="inline-control">
                <span>Prazo</span>
                <div class="prazo-grid">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Dias</mat-label>
                    <input matInput [currencyMask]="integerMask" formControlName="diasLiberacaoReserva" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-icon matPrefix class="material-symbols-outlined">bolt</mat-icon>
                    <mat-label>Ação ao vencer</mat-label>
                    <mat-select formControlName="idModoAoVencerAutomacaoOrdemServico">
                      @for (opcao of opcoesAoVencer; track opcao.idOpcaoAutomacao) {
                        <mat-option [value]="opcao.idOpcaoAutomacao">{{ opcao.rotulo }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              @if (isNotificar) {
                <div class="inline-control">
                  <span>Notificar</span>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-icon matPrefix class="material-symbols-outlined">group</mat-icon>
                    <mat-label>Selecionar destinatários</mat-label>
                    <mat-select formControlName="destinatariosLiberacaoReserva" multiple panelClass="panel-com-busca">
                      <mat-select-trigger>
                        <span class="d-inline-flex align-items-center gap-1 overflow-hidden">
                          @for (chave of model.get('destinatariosLiberacaoReserva')?.value; track chave) {
                            <span class="status-badge badge-azul">
                              {{ labelDestinatario(chave) }}
                              <button
                                type="button"
                                class="badge-close-btn"
                                matTooltip="Remover"
                                (click)="removerDestinatario(chave, $event)">
                                <mat-icon>close</mat-icon>
                              </button>
                            </span>
                          }
                        </span>
                      </mat-select-trigger>

                      <div class="select-search-wrapper">
                        <input
                          class="select-search-input inputSearchSelect"
                          [(ngModel)]="buscaDestinatario"
                          [ngModelOptions]="{ standalone: true }"
                          autocomplete="off"
                          placeholder="Pesquisar..."
                          (keydown)="$event.stopPropagation()"
                          (keydown.enter)="$event.preventDefault()" />
                      </div>

                      @if (filtrarDestinatarios(destinatariosDoCard).length) {
                        <mat-optgroup label="Do card">
                          @for (
                            destinatario of filtrarDestinatarios(destinatariosDoCard);
                            track destinatario.valor
                          ) {
                            <mat-option [value]="destinatario.valor">{{ destinatario.label }}</mat-option>
                          }
                        </mat-optgroup>
                      }
                      @if (filtrarDestinatarios(destinatariosPorPerfil).length) {
                        <mat-optgroup label="Por perfil">
                          @for (
                            destinatario of filtrarDestinatarios(destinatariosPorPerfil);
                            track destinatario.valor
                          ) {
                            <mat-option [value]="destinatario.valor">{{ destinatario.label }}</mat-option>
                          }
                        </mat-optgroup>
                      }
                      @if (filtrarDestinatarios(destinatariosPorUsuario).length) {
                        <mat-optgroup label="Por usuário">
                          @for (
                            destinatario of filtrarDestinatarios(destinatariosPorUsuario);
                            track destinatario.valor
                          ) {
                            <mat-option [value]="destinatario.valor">{{ destinatario.label }}</mat-option>
                          }
                        </mat-optgroup>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              @if (isModoAoVencerEscolhido) {
                <p class="info-hint mt-0">{{ notaLiberacao }}</p>
              }
            </div>
          </div>
        </div>
      </section>

      <app-footer-action
        [isLoadingSalvar]="salvando"
        [isSalvarDisabled]="salvando"
        salvarLabel="Salvar automações"
        (salvar)="salvar()"
        (cancelar)="descartar()">
        <span class="order-first text-secondary align-self-center me-auto">{{ estadoRodape }}</span>
      </app-footer-action>
    }
  </div>
</div>
